import PicGetRequest from '../PicGetRequest';
import { prtErr } from '../../utils/prt';


/* This api will return a the participant object if it exist, otherwise it will return an empty object   */
const getAttendeeStatus = (event_id, participantEmail) => {
   
    let _self = this;
    let apiPromise  = new Promise (function resolver(resolve, reject) {   
            /* make api call */
            let getParticipantRequest = new PicGetRequest("GetAttendeeStatus");
            getParticipantRequest
                .setUserId(participantEmail)
                .setUri(`/event/${event_id}/participant/${participantEmail}`)
                // .setAuthToken(token)  /* set token for internal request */
                .setLogTrace(true);
            getParticipantRequest.exec().then((response) => {
                if (!response) {console.log(`No response => /${response}/`)}
                let participant = response.data;
                resolve(participant)
            }).catch(() => {
                /* api does not provide test for a status of 404, just return empty string*/
                let error = getParticipantRequest.getError(); /* print notification below but propagate actual error below for debugging purposes */
                prtErr(`Error: encountered when calling getAttendeeStatus api for event id ${event_id} and participant ${participantEmail}`);
                reject(error)
            })
    }); /* end Promise */
    return apiPromise;
}

export default getAttendeeStatus;





// WEBPACK FOOTER //
// ./src/apis/participant/getAttendeeStatus.js